module.exports = {"TXTWCL_Deposit":{"id":"TXTWCL_Deposit","defaultMessage":"Κατάθεση","track":"Deposit"}}